"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const run_when_visible_1 = require("../utils/run-when-visible");
class Carousel {
    constructor(elements) {
        elements.forEach((element) => (0, run_when_visible_1.RunWhenVisible)(element, Carousel.initialize));
    }
    static async initialize() {
        const { Swiper, Navigation, Scrollbar } = await Promise.resolve().then(() => __importStar(require(
        /* webpackChunkName: "swiper" */
        'swiper')));
        Swiper.use([Navigation, Scrollbar]);
        const setInViewClass = (slider) => {
            const columns = slider.el.dataset.columns || null;
            if (!columns) {
                return;
            }
            const start = slider.activeIndex;
            const end = start + (columns - 1);
            slider.slides.forEach((item, index) => {
                if (index >= start && index <= end) {
                    item.classList.add('slide-in-view');
                }
                else {
                    item.classList.remove('slide-in-view');
                }
            });
        };
        new Swiper('.swiper-carousel', {
            slidesPerView: 'auto',
            loop: false,
            spaceBetween: 0,
            initialSlide: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            on: {
                slideChange: (swiper) => {
                    var _a;
                    (_a = swiper.navigation.prevEl) === null || _a === void 0 ? void 0 : _a.classList.remove('unchanged');
                },
                afterInit: (slider) => {
                    setInViewClass(slider);
                },
                activeIndexChange: setInViewClass,
            },
        });
    }
}
exports.Carousel = Carousel;
